module.exports = __webpack_public_path__ + "static/media/plane-mobile.f433288e.png";